import { render, staticRenderFns } from "./FooterBackToTop.vue?vue&type=template&id=ebbbc01c&"
import script from "./FooterBackToTop.vue?vue&type=script&lang=js&"
export * from "./FooterBackToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports